/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { animate, style, transition, trigger } from '@angular/animations';

export const inOutAnimation = trigger('inOutAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('{{ inDuration }}ms', style({ opacity: 1 }))], {
    params: { inDuration: 300 },
  }),
  transition(':leave', [style({ opacity: 1 }), animate('{{ outDuration }}ms', style({ opacity: 0 }))], {
    params: { outDuration: 300 },
  }),
]);

export const slideInOutAnimation = trigger('slideInOut', [
  transition(
    ':enter',
    [
      style({ opacity: 0, height: '0', overflow: 'hidden' }),
      animate('{{ inDuration }}ms', style({ height: '*' })),
      animate('{{ inDuration }}ms', style({ opacity: 1 })),
    ],
    { params: { inDuration: 300 } },
  ),
  transition(
    ':leave',
    [
      style({ opacity: 1, height: '*' }),
      animate('{{ outDuration }}ms', style({ opacity: 0, height: 0, overflow: 'hidden' })),
    ],
    { params: { outDuration: 300 } },
  ),
]);
